import ApiDatabase from 'server';
import UseContext from 'hooks/useContext';
import Modalheader from 'components/modal/components/header';
import ModalBody from 'components/modal/components/body';
import PerimeterModalFooter from 'components/modal/dataModal/data/perimeter/PerimeterModalFooter';
import usePerimeterModal from 'components/modal/dataModal/data/perimeter/usePerimeterModal';
import { ARCHIVE_ERROR_OVERRIDES } from 'components/perimeter/perimeterErrors';
import {
  fillText,
  getCountText,
  perimeterText,
} from 'components/perimeter/perimeterText';

// Only finished missions are left on the perimeter, and no member: nothing to
// transfer, the archive is a plain confirmation.
const ArchivePerimeterModal = () => {
  const { language } = UseContext();
  const t = (key) => perimeterText(language, key);
  const { data, isSaving, setIsSaving, close, succeed, fail } =
    usePerimeterModal();
  const { idCompany, perimeter, usage } = data;
  const finishedMissions = Number(usage?.finishedMissions) || 0;

  // Without any finished mission there is no history to mention.
  const description = [
    finishedMissions > 0
      ? getCountText(language, 'archive.finishedMissions', finishedMissions)
      : '',
    t('archive.notProposed'),
  ]
    .filter(Boolean)
    .join(' ');

  const handleConfirm = () => {
    if (isSaving) return;
    setIsSaving(true);
    ApiDatabase.postArchiveAdminCompanyPerimeter(
      { idCompany, id: perimeter?.id, transferTo: null },
      () => succeed(t('toast.archived')),
      (err) => fail(err, { overrides: ARCHIVE_ERROR_OVERRIDES }),
    );
  };

  return (
    <>
      <Modalheader hide={close} hideShow={true}>
        {fillText(t('archive.title'), { name: perimeter?.name })}
      </Modalheader>
      <ModalBody>
        <p className={'text-sm text-gray-600'}>{description}</p>
      </ModalBody>
      <PerimeterModalFooter
        confirmLabel={t('archive.confirm')}
        savingLabel={t('archive.archiving')}
        isSaving={isSaving}
        onCancel={close}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default ArchivePerimeterModal;
